import { render, staticRenderFns } from "./BetSetting.vue?vue&type=template&id=1317419a&"
import script from "./BetSetting.vue?vue&type=script&lang=js&"
export * from "./BetSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports